import { Component, Input, OnInit } from '@angular/core';
import { ActionPlanSubSubpanelConfigurations } from './action-plan-sub-subpanel-configurations';
import { KlaHttpService } from '../services/kla.http.service';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-action-plan-sub-subpanel',
  templateUrl: './action-plan-sub-subpanel.component.html',
  styleUrls: ['./action-plan-sub-subpanel.component.scss'],
  standalone: true,
  imports: [ CommonModule, MatExpansionModule, DynamicContentComponent, MatTableModule ]
})
export class ActionPlanSubSubpanelComponent implements OnInit {

  parentOpenState = false;
  panelsOpenStates: boolean[] = [];
  toolTipPosition = 'above';

  @Input() config: ActionPlanSubSubpanelConfigurations;
  @Input() color: string;
  @Input() collapseChildren = false;
  @Input() categories: any[];
  @Input() columnNames: any;
  @Input() columnsActive: any;

  constructor(
    private httpService: KlaHttpService
  ) {
  }

  get displayedColumns(): string[] {
    if (!this.columnsActive) {
      return ['action', 'description', 'timeline', 'status', 'coBenefits'];
    }
    const cols = [];
    if (this.columnsActive.column1active) {
      cols.push('action');
    }
    if (this.columnsActive.column2active) {
      cols.push('description');
    }
    if (this.columnsActive.column3active) {
      cols.push('timeline');
    }
    if (this.columnsActive.column4active) {
      cols.push('status');
    }
    if (this.columnsActive.column5active) {
      cols.push('coBenefits');
    }
    return cols;
  }

  ngOnInit() {
    this.toolTipPosition = (this.isiOS() && this.isTabletPortrait()) ? 'below' : 'above';
  }

  handleParentOpened() {
    this.parentOpenState = true;
  }

  handleParentClosed() {
    this.parentOpenState = false;
    if (this.collapseChildren) {
      this.closeAllPanels();
    }
  }

  private closeAllPanels() {
    for (let i = 0; i < this.panelsOpenStates.length; i++) {
      this.panelsOpenStates[i] = false;
    }
  }

  addAlpha(color: string, opacity: number, device: string = 'xl'): string {
    if (device != 'xs' || this.isMobile()) {
      const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    } else {
      return;
    }
  }

  isMobile() {
    return window.innerWidth < 767;
  }

  getActionTextColor() {
    if (this.isMobile()) {
      return '#fff';
    } else {
      return this.color;
    }
  }

  getCoBenefitIconPath(data): string {
    const category = this.categories.find(x => (x.id == data.id || x.title == data.title));
    let iconPath = '';
    if (typeof category != 'undefined' && category.imageId) {
      iconPath = this.httpService.getImagePath(category.imageId.toString(), 64);
    }
    return (iconPath != '' && category.imageId) ? iconPath : '/assets/action-plan-icons/place-holder-icon.png';
  }

  getCoBenefitTitle(category): string {
    return category.title;
  }

  applyStyles(text) {
    if (!text) {
      return;
    }
    const styleId = 'panel-mat-tooltip-line-height';
    const existingStyle = document.getElementById(styleId);
    if (typeof (existingStyle) != 'undefined' && existingStyle != null) {
      existingStyle.remove();
    }
    const style = document.createElement('style');
    const lineHeight = 1.0 + ((0.2 + (text.length * 0.004)) * text.length);

    style.id = styleId;
    style.innerHTML = `.mat-tooltip {
      line-height: ${lineHeight} !important;
    }
    `;
    document.getElementsByTagName('head')[0].appendChild(style);
  }

  isTabletPortrait() {
    return window.innerWidth < 1023;
  }

  isiOS() {
    const iDevices = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ];

    if (!!navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) {
          return true;
        }
      }
    }

    return false;
  }

  isActionLayout(param: any): boolean {
    return param.actionLayout;
  }

  onArrowKeydown(e: KeyboardEvent, i: number) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      this.panelsOpenStates[i] = !this.panelsOpenStates[i];
    }
  }

  getRowAriaLabel(row: any): string {
    const parts: string[] = [];
    if (row.title) parts.push(row.title);
    if (row.timeline) parts.push(row.timeline);
    if (row.status?.value) {
      parts.push(row.status.value);
    } else if (!row.actionLayout) {
      parts.push('Awaiting Resources');
    }
    return parts.join(', ');
  }

}
